import cn from 'classnames';
import { Tooltip as ReactTooltip } from 'react-tooltip';

/** Shared id for anchors using `data-tooltip-id` + `data-tooltip-content`. */
export const APP_TOOLTIP_ID = 'app-tooltip';

/**
 * Single root-mounted tooltip instance. Anchors anywhere in the app can opt in
 * via data attributes without nesting a tooltip inside overflow containers.
 */
export function GlobalTooltip() {
  return (
    <ReactTooltip
      className={cn(
        '!z-[110] flex max-w-[160px] flex-col !overflow-visible !rounded-[6px] !bg-gray-800 !duration-200',
      )}
      id={APP_TOOLTIP_ID}
      opacity={1}
      place="top"
      positionStrategy="fixed"
    />
  );
}
